import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getWhatsappOpeningMessagesQueryKey } from "modules/campaigns/lib/templates/openingMessages/whatsappOpeningMessagesQuery"
import { useTranslation } from "react-i18next"
import { UpsertWhatsappOpeningMessageSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"

export const useCreateWhatsappOpeningMessageMutation = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      props,
    }: {
      props: z.infer<typeof UpsertWhatsappOpeningMessageSchema>
    }) => {
      const { data } = await axios.post(`/integrations/whatsapp/opening-messages`, props)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getWhatsappOpeningMessagesQueryKey() })
      toast.success(t("campaigns.templates.openingMessages.createdSuccess"))
    },
  })
}
